import { render, staticRenderFns } from "./NavigationTabs.vue?vue&type=template&id=5ac1681a&scoped=true"
import script from "./NavigationTabs.vue?vue&type=script&lang=js"
export * from "./NavigationTabs.vue?vue&type=script&lang=js"
import style0 from "./NavigationTabs.vue?vue&type=style&index=0&id=5ac1681a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac1681a",
  null
  
)

export default component.exports